import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <h1>Beti Bachao Beti Padhao - Admin Panel</h1>

        <button
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>

        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/dashboard" className="nav-link" onClick={closeMobileMenu}>Dashboard</Link>
          <Link to="/users" className="nav-link" onClick={closeMobileMenu}>Users</Link>
          <Link to="/notifications" className="nav-link" onClick={closeMobileMenu}>Notifications</Link>
          <Link to="/home-slides" className="nav-link" onClick={closeMobileMenu}>Home Slides</Link>
          <Link to="/photo-slides" className="nav-link" onClick={closeMobileMenu}>Photo Gallery</Link>
          <Link to="/women-initiatives" className="nav-link" onClick={closeMobileMenu}>Women Initiatives</Link>
          <Link to="/awareness-images" className="nav-link" onClick={closeMobileMenu}>Awareness Images</Link>
          <Link to="/awareness-videos" className="nav-link" onClick={closeMobileMenu}>Awareness Videos</Link>
          <Link to="/campaigns" className="nav-link" onClick={closeMobileMenu}>Campaigns</Link>
          <Link to="/schemes" className="nav-link" onClick={closeMobileMenu}>Schemes</Link>
          <Link to="/inspirational-women" className="nav-link" onClick={closeMobileMenu}>Inspirational Women</Link>
          <Link to="/feedbacks" className="nav-link" onClick={closeMobileMenu}>Feedbacks</Link>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </div>
    </header>
  );
}

export default Header;
